import { useEffect } from "react";

// Même titre que le HTML pré-rendu de l'accueil (scripts/prerendu.js).
const DEFAULT_TITLE = "Le savez-vous ? Une histoire vraie par jour en 90 secondes";
const SUFFIX = " · Le savez-vous ?";
const SITE = "https://le-savez-vous.com";

/**
 * Dependency-free per-route metadata. Updates document.title and, optionally,
 * the meta description while the component is mounted, then restores the
 * previous values on unmount. Useful for a SPA without server-side rendering:
 * gives each route a distinct, shareable tab title and a description that
 * JS-rendering crawlers (e.g. Googlebot) can pick up.
 *
 * Pose aussi le `<link rel="canonical">` de la page (adresse sans paramètres) :
 * avant, toutes les routes de l'application disaient « je suis l'accueil ».
 */
export default function usePageMeta(title, description) {
    useEffect(() => {
        const prevTitle = document.title;
        document.title = title ? `${title}${SUFFIX}` : DEFAULT_TITLE;

        let metaEl = null;
        let prevDesc = null;
        if (description) {
            metaEl = document.querySelector('meta[name="description"]');
            if (metaEl) {
                prevDesc = metaEl.getAttribute("content");
                metaEl.setAttribute("content", description);
            }
        }

        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", `${SITE}${window.location.pathname}`);

        return () => {
            document.title = prevTitle;
            if (metaEl && prevDesc != null) {
                metaEl.setAttribute("content", prevDesc);
            }
        };
    }, [title, description]);
}
